<div class="form-field">
  @if(label) {
    <label
      class="form-label"
      [class.sr-only]="labelSrOnly === true"
      [for]="labelId">
      {{ label }}
      @if(required) {
        <span class="required">*</span>
      }
    </label>
  }
  @if(helpText) {
    <span class="form-helptext" [id]="helpTextId" [title]="helpText">
      {{ helpText }}
    </span>
  }
  <ng-content></ng-content>
</div>
